import { SET_FLIGHT } from '../actions/actionTypes';

const initialState = {};

export const flightReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLIGHT:
      return { ...action.data };
    default:
      return state;
  }
};